import { ExtraCards } from "../GameModule";

export const EXTRA_CARDS: ExtraCards = {
  doctor_strange: [
    { jsonId: "09032" },
    { jsonId: "09033" },
    { jsonId: "09034" },
    { jsonId: "09035" },
    { jsonId: "09036" },
  ],
  ant: [{ jsonId: "12001c" }],
  wsp: [{ jsonId: "13001c" }],
  ironheart: [{ jsonId: "29002a" }, { jsonId: "29003a" }],
  spdr: [{ jsonId: "31002a" }],
  storm: [
    { jsonId: "36002" },
    { jsonId: "36003" },
    { jsonId: "36004" },
    { jsonId: "36005" },
  ],
  angel: [{ jsonId: "42001c" }],
  iceman: [
    { jsonId: "46002" },
    { jsonId: "46002" },
    { jsonId: "46002" },
    { jsonId: "46002" },
    { jsonId: "46002" },
    { jsonId: "46002" },
  ],
};
